import React from "react";
import { App, AppProps } from "./App";
import { createRoot } from "react-dom/client";
import "./index.css";

export function initAgentWidget(element: HTMLElement, config: AppProps) {
  const root = createRoot(element);
  root.render(<App {...config} />);
}
